import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
/**
 * Extracted to handle async loading
 */
export const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
